export const MaxConsecutiveDayWeekType = Object.freeze({
    RollingWeek: 0,
    FixedWeek: 1,
});

